import { IKeHoachKyHieu } from "../../../model/respone/ke-hoach/IKeHoachKyHieu";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eKeHoachKyHieuActionsObj = {
  LOAD_START: undefined,
  LOAD_SUCCESS: {} as IKeHoachKyHieu[],
  LOAD_ERRR: "",
};
export const eKeHoachKyHieuActionIds = generateActionTypeIds(
  eKeHoachKyHieuActionsObj,
  "KE_HOACH_KY_HIEU"
);
export type IKeHoachKyHieuActionTypes = IGenericActionType<
  typeof eKeHoachKyHieuActionsObj,
  "KE_HOACH_KY_HIEU"
>;
